module.exports = __webpack_public_path__ + "img/relationshipsIco.c8b9f65d.svg";